import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Auth
export const authRegister = (email, password, name) =>
  api.post("/auth/register", { email, password, name }).then((r) => r.data);
export const authLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);

export const listFolders = () => api.get("/folders").then((r) => r.data);
export const createFolder = (name) => api.post("/folders", { name }).then((r) => r.data);
export const renameFolder = (id, name) => api.patch(`/folders/${id}`, { name }).then((r) => r.data);
export const deleteFolder = (id) => api.delete(`/folders/${id}`).then((r) => r.data);

export const listTags = () => api.get("/tags").then((r) => r.data);
export const createTag = (name, color = "stone") => api.post("/tags", { name, color }).then((r) => r.data);
export const deleteTag = (id) => api.delete(`/tags/${id}`).then((r) => r.data);

export const listCitations = () => api.get("/citations").then((r) => r.data);
export const createCitation = (data) => api.post("/citations", data).then((r) => r.data);
export const updateCitation = (id, data) => api.patch(`/citations/${id}`, data).then((r) => r.data);
export const deleteCitation = (id) => api.delete(`/citations/${id}`).then((r) => r.data);

export const fetchMetadata = (query) => api.post("/citations/fetch", { query }).then((r) => r.data);

export const getCitationApa = (id) => api.get(`/citations/${id}/apa`).then((r) => r.data);
export const getCitationBibtex = (id) => api.get(`/citations/${id}/bibtex`).then((r) => r.data);
export const getCitationFormatted = (id, style = "apa7") =>
  api.get(`/citations/${id}/formatted`, { params: { style } }).then((r) => r.data);
export const exportAllBibtex = (folderId) =>
  api.get(`/export/bibtex`, { params: folderId ? { folder_id: folderId } : {} }).then((r) => r.data);
export const exportAllApa = (folderId) =>
  api.get(`/export/apa`, { params: folderId ? { folder_id: folderId } : {} }).then((r) => r.data);
export const exportAllStyle = (style = "apa7", folderId) =>
  api
    .get(`/export/style`, { params: { style, ...(folderId ? { folder_id: folderId } : {}) } })
    .then((r) => r.data);

export const listConnections = () => api.get("/connections").then((r) => r.data);
export const createConnection = (source_id, target_id, label = "") =>
  api.post("/connections", { source_id, target_id, label }).then((r) => r.data);
export const updateConnection = (id, label) =>
  api.patch(`/connections/${id}`, { label }).then((r) => r.data);
export const deleteConnection = (id) => api.delete(`/connections/${id}`).then((r) => r.data);

export const getMapLayout = () => api.get("/map/layout").then((r) => r.data);
export const saveMapLayout = (positions) =>
  api.put("/map/layout", { positions }).then((r) => r.data);

export const listKeywords = () => api.get("/keywords").then((r) => r.data);
export const renameKeyword = (from, to) =>
  api.post("/keywords/rename", { from, to }).then((r) => r.data);
export const deleteKeyword = (name) =>
  api.delete(`/keywords/${encodeURIComponent(name)}`).then((r) => r.data);
export const setKeywordStyle = (name, color) =>
  api.put(`/keywords/${encodeURIComponent(name)}/style`, { color }).then((r) => r.data);

export const CITATION_STYLES = [
  { id: "apa7", label: "APA 7" },
  { id: "mla9", label: "MLA 9" },
  { id: "chicago", label: "Chicago" },
  { id: "harvard", label: "Harvard" },
];

export const listStickers = () => api.get("/stickers").then((r) => r.data);
export const createSticker = (data) => api.post("/stickers", data).then((r) => r.data);
export const updateSticker = (id, data) => api.patch(`/stickers/${id}`, data).then((r) => r.data);
export const deleteSticker = (id) => api.delete(`/stickers/${id}`).then((r) => r.data);
